module.exports = __webpack_public_path__ + "3f6b1eed8a0832d6f316fc26526348a8.svg";